// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ZQoyezZkwBjmOYzBn_d2 {
  display: flex;
  align-items: center;
  gap: 6px;
  background: none;
  border: none;
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  transition: all 0.2s ease-in-out;
  position: relative;
}
.ZQoyezZkwBjmOYzBn_d2:hover {
  background-color: rgb(38, 38, 38);
}
.ZQoyezZkwBjmOYzBn_d2:hover .d1ecWUeF8OrHOlupkdYb {
  filter: brightness(1.2) contrast(1.05);
  transform: scale(1.03);
}
.ZQoyezZkwBjmOYzBn_d2:hover .qnMxuGCvW8cxt6tgMEd1 {
  opacity: 1;
  transform: translateY(0px);
}
.ZQoyezZkwBjmOYzBn_d2[data-state=open] {
  background-color: rgb(38, 38, 38);
}
.ZQoyezZkwBjmOYzBn_d2[data-state=open] .qnMxuGCvW8cxt6tgMEd1 {
  transform: rotate(180deg);
  opacity: 1;
}

.d1ecWUeF8OrHOlupkdYb {
  height: 48px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  transition: all 0.2s ease-in-out;
}

.qnMxuGCvW8cxt6tgMEd1 {
  opacity: 0.6;
  transition: all 0.2s ease-in-out;
  color: white;
  flex-shrink: 0;
}

.W7dhmB8_b1qRPBUlAAsg {
  min-width: 240px;
  background-color: rgba(30, 30, 30, 0.95);
  color: white;
  border-radius: 8px;
  padding: 6px;
  box-shadow: 0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2);
  animation-duration: 400ms;
  animation-timing-function: cubic-bezier(0.16, 1, 0.3, 1);
  will-change: transform, opacity;
  z-index: 10;
  backdrop-filter: blur(8.5px);
  -webkit-backdrop-filter: blur(8.5px);
}

.uEEKMtAX9VvmUGqLXWSf {
  font-size: 11px;
  font-weight: 600;
  padding: 8px 12px 4px;
  color: #9ca3af;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.PgxCpPyo267rvAxuRj3P {
  height: 1px;
  background-color: rgba(255, 255, 255, 0.1);
  margin: 4px 4px 6px;
}

.fdtkSgIhUMQL2YcaWNLA {
  all: unset;
  box-sizing: border-box;
  font-size: 14px;
  line-height: 1.2;
  border-radius: 6px;
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 8px 12px;
  position: relative;
  user-select: none;
  cursor: pointer;
  margin: 1px 0;
  transition: background-color 0.15s ease-in-out;
}
.fdtkSgIhUMQL2YcaWNLA[data-highlighted] {
  background-color: rgba(255, 255, 255, 0.1);
  outline: none;
}

.QdLZA97lnIspHt4J2_Qk {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 12px;
}

.ZjnRgtW8BxFDsGbgh102 {
  font-weight: 500;
  color: white;
}

.nuWnLWmX1SePoFnKmlRd {
  font-size: 10px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 4px;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  background-color: #774dee;
  color: white;
  flex-shrink: 0;
}`, "",{"version":3,"sources":["webpack://./src/shared/navigation/components/AppSwitcher.module.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,gBAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;EACA,eAAA;EACA,gCAAA;EACA,kBAAA;AAFF;AAIE;EACE,iCAAA;AAFJ;AAII;EACE,sCAAA;EACA,sBAAA;AAFN;AAKI;EACE,UAAA;EACA,0BAAA;AAHN;AAOE;EACE,iCAAA;AALJ;AAOI;EACE,yBAAA;EACA,UAAA;AALN;;AAUA;EACE,YAAA;EACA,WAAA;EACA,gBAAA;EACA,mBAAA;EACA,gCAAA;AAPF;;AAUA;EACE,YAAA;EACA,gCAAA;EACA,YAAA;EACA,cAAA;AAPF;;AAUA;EACE,gBAAA;EACA,wCAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,iGACE;EAEF,yBAAA;EACA,wDAAA;EACA,+BAAA;EACA,WAAA;EACA,4BAAA;EACA,oCAAA;AATF;;AAYA;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,yBAAA;EACA,qBAAA;AATF;;AAYA;EACE,WAAA;EACA,0CAAA;EACA,mBAAA;AATF;;AAYA;EACE,UAAA;EACA,sBAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,kBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,8CAAA;AATF;AAWE;EACE,0CAAA;EACA,aAAA;AATJ;;AAaA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,WAAA;EACA,SAAA;AAVF;;AAaA;EACE,gBAAA;EACA,YAAA;AAVF;;AAaA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EACA,yBAAA;EACA,qBAAA;EACA,yBAAA;EACA,YAAA;EACA,cAAA;AAVF","sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"trigger": `ZQoyezZkwBjmOYzBn_d2`,
	"logo": `d1ecWUeF8OrHOlupkdYb`,
	"arrow": `qnMxuGCvW8cxt6tgMEd1`,
	"content": `W7dhmB8_b1qRPBUlAAsg`,
	"label": `uEEKMtAX9VvmUGqLXWSf`,
	"separator": `PgxCpPyo267rvAxuRj3P`,
	"item": `fdtkSgIhUMQL2YcaWNLA`,
	"itemContent": `QdLZA97lnIspHt4J2_Qk`,
	"appName": `ZjnRgtW8BxFDsGbgh102`,
	"badge": `nuWnLWmX1SePoFnKmlRd`
};
export default ___CSS_LOADER_EXPORT___;
